// Components
import Svg from 'src/Components/shared/Svg'

export const MarkerSvg = props => (
  <Svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.81693 0.5C11.0055 0.5 13.373 2.90573 13.4112 6.09427C13.2012 8.38544 12.2465 10.6384 10.6045 12.8914C8.98161 15.1062 8.04605 16.3091 7.81693 16.5C7.58781 16.3091 6.63316 15.1253 4.99115 12.8914C3.36824 10.6575 2.43268 8.38544 2.22266 6.09427C2.26084 2.90573 4.62838 0.5 7.81693 0.5ZM7.81693 8.07995C8.98161 8.07995 9.80261 7.25895 9.80261 6.09427C9.80261 4.92959 8.98161 4.10859 7.81693 4.10859C6.65225 4.10859 5.83125 4.92959 5.83125 6.09427C5.83125 7.25895 6.65225 8.07995 7.81693 8.07995Z'
      fill='var(--brand-neutral-warm-500)'
    />
  </Svg>
)
